export type TranslationLanguage = {
  id: string;
  language: string;
  code: string;
  countryCode: string;
};

export const TRANSLATION_LANGUAGES: TranslationLanguage[] = [
  { id: "1", language: "English", code: "en", countryCode: "gb" },
  { id: "2", language: "Spanish", code: "es", countryCode: "es" },
  { id: "3", language: "French", code: "fr", countryCode: "fr" },
  { id: "4", language: "German", code: "de", countryCode: "de" },
  { id: "5", language: "Italian", code: "it", countryCode: "it" },
  { id: "6", language: "Portuguese", code: "pt", countryCode: "pt" },
  { id: "7", language: "Russian", code: "ru", countryCode: "ru" },
  { id: "8", language: "Chinese", code: "zh", countryCode: "cn" },
  { id: "9", language: "Japanese", code: "ja", countryCode: "jp" },
  { id: "10", language: "Korean", code: "ko", countryCode: "kr" },
];
